import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Layout from "Layout";
import NonAuthLayout from "Layout/NonLayout";
import AuthProtected from "./AuthProtected";
import Routepage from "./allRoutes";

const RouteIndex = () => {
  // Routepage() فقط localStorage را (بدون هیچ state ری‌اکتیوی) در لحظه‌ی رندر می‌خواند. اگر
  // RouteIndex به تغییر مسیر هم گوش نمی‌داد، فقط یک‌بار (همان اولین رندر برنامه، معمولاً قبل از
  // لاگین) اجرا می‌شد و لیست روت‌ها برای همیشه «قفل» می‌ماند؛ یعنی بعد از لاگین موفق و
  // navigate('/ProformaInvoices')، چون خودِ RouteIndex هرگز دوباره رندر نمی‌شد، مسیر
  // /ProformaInvoices اصلاً در <Routes> وجود نداشت (چون موقع اولین رندر هنوز توکنی نبود) و کاربر
  // یا به صفحه‌ی سفید می‌رسید یا به لاگین برمی‌گشت — مگر با رفرش کامل صفحه. useLocation() اینجا
  // فقط برای subscribe شدن به تغییر مسیر است تا با هر navigate، Routepage() دوباره با
  // localStorage تازه اجرا شود.
  useLocation();
  const [authProtectedRoutes, publicRoutes] = Routepage();

  return (
    <React.Fragment>
      <Routes>
        {/* مسیرهای محافظت شده */}
        {authProtectedRoutes?.map((route: any, idx: any) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}

        {/* مسیرهای عمومی */}
        {publicRoutes?.map((route: any, idx: any) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
